'use client';

import { usePrefersReducedMotion } from '@shared/utils';
import { useEffect, useState } from 'react';

const WINNERS_STORIES_STACK_ROTATION_MS = 5500;

function useWinnersStoriesStackRotation(storyCount: number, isPaused = false): number {
  const [activeIndex, setActiveIndex] = useState(0);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (storyCount <= 1 || prefersReducedMotion || isPaused) return undefined;

    const timer = window.setInterval(() => {
      setActiveIndex(current => (current + 1) % storyCount);
    }, WINNERS_STORIES_STACK_ROTATION_MS);

    return () => window.clearInterval(timer);
  }, [storyCount, prefersReducedMotion, isPaused]);

  return activeIndex;
}

export { useWinnersStoriesStackRotation, WINNERS_STORIES_STACK_ROTATION_MS };
